import httpClient from '../api/httpClient';
import API_CONFIG, { getApiBaseUrl } from '../config/api.config';

const ENDPOINT = API_CONFIG.ENDPOINTS.DOCUMENTS;

// Helper to get absolute document URL for preview/download
export const getDocumentUrl = (relativePath: string): string => {
  if (!relativePath) return '';
  
  console.debug('[getDocumentUrl] Input relativePath:', relativePath);
  
  // If already absolute (starts with http), return as is
  if (/^https?:\/\//i.test(relativePath)) {
    console.debug('[getDocumentUrl] Already absolute:', relativePath);
    return relativePath;
  }
  
  // Handle paths that start with /uploads (from backend)
  let cleanPath = relativePath;
  if (cleanPath.startsWith('/uploads/')) {
    // Remove leading slash for URL construction
    cleanPath = cleanPath.substring(1);
  } else if (cleanPath.startsWith('uploads/')) {
    // Already clean, use as is
  } else {
    // Add uploads/documents/ prefix for bare filenames
    cleanPath = 'uploads/documents/' + cleanPath.replace(/^\/+/, '');
  }
  
  // Compose full URL
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/${cleanPath}`;
  
  console.debug('[getDocumentUrl] Final URL:', url);
  return url;
};

export const documentApi = {
  async uploadDocument(appointmentId: string, file: File, type: string, description?: string) {
    const formData = new FormData();
    formData.append('appointmentId', appointmentId);
    formData.append('type', type);
    if (description) formData.append('description', description);
    formData.append('file', file);
    const res = await httpClient.post(API_CONFIG.getUrl(ENDPOINT), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  async getDocuments(appointmentId: string) {
    const res = await httpClient.get(API_CONFIG.getUrl(ENDPOINT), { params: { appointmentId } });
    return res.data;
  },

  async deleteDocument(id: string) {
    const res = await httpClient.delete(API_CONFIG.getUrl(`${ENDPOINT}/${id}`));
    return res.data;
  },

  async updateDocument(id: string, data: { type?: string; description?: string }) {
    const res = await httpClient.patch(API_CONFIG.getUrl(`${ENDPOINT}/${id}`), data);
    return res.data;
  },
};
